import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTicketType } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useCreateTicketType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createTicketType,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-types'] });
            toast.success('Type de ticket créé avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création du type de ticket');
        },
    });
};
